export class UserLeads {
     currentLeadsCount          :number;
     noWorkCount                :number;
     notConnectedCount          :number;
     followUpsCount             :number;
     visitOnCounts              :number;
     visitDoneCount             :number;
     visitDeadCount             :number;
     otherProjectsCount         :number;
     resaleCount                :number;
     alreadyBookedCount         :number;
     bookedDone                 :number;
     deadCount                  :number;
     rentCount                  :number;
     plotCount                  :number;
     duplicateCount             :number;
     rawLeadsCount              :number;
    }